import React from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { get, debounce } from 'lodash';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import InputSelect from '../components/inputs/InputSelect';
import InputText from '../components/inputs/InputText';
import { API_HOST } from '../consts';

class BaseFiltroRecurso extends React.Component {
  constructor(props) {
    super(props);
    this.firstTimeOpening = true;
    this.onOpened = this.onOpened.bind(this);
  }

  state = {
    aplicacao: [],
    criado_por: [],
    status: [],
    nome_requerente: [],
    metadata: []
  };

  shouldDisplayDefault(field) {
    const { metadata } = this.state;
    return get(metadata, field);
  }

  getValues(v) {
    const values = { ...v };
    return values;
  }

  onOpened() {
    // O timeout é para não deixar a animação do modal lenta
    setTimeout(() => {
      if (this.firstTimeOpening) {
        this.fetchAplicacoes();
        this.fetchCriadoPor();
        this.fetchStatus();
        this.firstTimeOpening = false;
      }
    }, 1000);

    const { initialValues } = this.props;
    this.formApi.setValues({ ...initialValues, ...this.values });
  }

  fetchAplicacoes() {
    axios.get(`${API_HOST}/aplicacoes/aplicacao`).then((response) => {
      this.setState({
        aplicacao: response.data.map((item) => ({
          value: item.id,
          label: item.nome
        }))
      });
    });
  }

  fetchCriadoPor() {
    axios.get(`${API_HOST}/itens/criado_por`).then((response) => {
      this.setState({
        criado_por: response.data.map((item) => ({
          value: item.id,
          label: `${item.first_name}  ${item.last_name}`
        }))
      });
    });
  }

  fetchStatus() {
    axios.get(`${API_HOST}/recursos/status`).then((response) => {
      this.setState({
        status: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  }

  toggle = () => {
    const { toggle } = this.props;
    this.values = this.formApi.getState().values;
    toggle();
  };

  handleSubmit = (values) => {
    this.buscarRecursos(this.getValues(values));
  };

  buscarRecursos(values) {
    return axios.get(`${API_HOST}/recursos/recurso`, { params: values });
  }

  renderFooter() {
    return null;
  }

  renderForm() {
    const { aplicacao, criado_por, status } = this.state;

    return (
      <Form
        style={{ height: '425px', backgroundColor: '#fff' }}
        onChange={(formState) => this.setState({ formState })}
        onValueChange={this.onValueChange}
        onSubmit={this.handleSubmit}
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
      >
        <div className="modal-separator">
          <h5>Dados Gerais</h5>
        </div>
        <div className="modal-body-inside">
          <div className="row mt-3">
            <InputText label="Código do Recurso" field="id" col="col-md-4" />
            <InputText label="Código do Item" field="item" col="col-md-4" />
            <InputSelect
              label="Status"
              col="col-md-4"
              field="status"
              options={status}
            />
            <InputSelect
              label="Aplicação"
              col="col-md-4"
              field="aplicacao"
              options={aplicacao}
            />
            <InputSelect
              label="Nome do Elaborador"
              col="col-md-6"
              field="criado_por"
              options={criado_por}
            />
            <InputText
              label="Nome do Candidato"
              col="col-md-6"
              field="nome_requerente"
            />
          </div>
        </div>
      </Form>
    );
  }

  render() {
    const { isOpen } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        toggle={this.toggle}
        size="lg"
        onOpened={() => this.onOpened()}
        onClosed={this.onExit}
      >
        <ModalHeader toggle={this.toggle}>Buscar recursos</ModalHeader>
        <ModalBody className="p-0">{this.renderForm()}</ModalBody>
        <ModalFooter>{this.renderFooter()}</ModalFooter>
      </Modal>
    );
  }
}

export default BaseFiltroRecurso;
